import React from "react";
import $ from "jquery";
import DashBoard from "./DashBoard";
import { Avatar, Breadcrumb, Layout, Menu, Select, Spin } from "antd";
import { HashRouter as Router, Redirect, Route, Switch as RouteSwitch } from "react-router-dom";
import {
    BellFilled,
    BellOutlined,
    BulbFilled,
    BulbOutlined,
    CaretLeftOutlined,
    CaretRightOutlined,
    ControlOutlined,
    DashboardOutlined,
    LineChartOutlined,
    LogoutOutlined,
    MenuFoldOutlined,
    MenuUnfoldOutlined,
    MobileFilled,
    MobileOutlined,
    NotificationFilled,
    NotificationOutlined,
    PieChartOutlined,
    QuestionOutlined,
    SettingOutlined,
    SlidersOutlined,
    ThunderboltFilled,
    ThunderboltOutlined,
    UserOutlined
} from "@ant-design/icons";

import ConfigGetter from "../utils/ConfigGetter";
import TradingViewChart from "../component/TradingViewChart";
import TradingViewTickers from "../component/TradingViewTickers";

import "../static/css/json.css";
import "../static/css/my.css";

import PortfolioMonitor from "./PortfolioMonitor";
import PortfolioMonitorConfig from "./PortfolioMonitorConfig";
import logo_large from "../static/img/logo_white_foreseem.svg";
import logo_small from "../static/img/logo_white.svg";
import default_avatar from "../static/img/default_avatar.png";
import { Switch } from "antd/es";
import openNotificationWithIcon from "../utils/Tools";
import { disable, enable } from "darkreader";

const { Header, Sider, Content } = Layout;
const SubMenu = Menu.SubMenu;
const cnf = ConfigGetter.getConfig();

const ico_map = {
    "Monitor": <DashboardOutlined/>,
    "Chart": <SlidersOutlined/>,
    "Analytics": <PieChartOutlined/>,
    "Account": <UserOutlined/>,
    "Control": <ControlOutlined/>,
};
const avatar_map = {
    "jesse": "https://www.foreseem.com/img/jesse.jpg",
    "kenny": "https://www.foreseem.com/img/kenny.jpg",
    "jun.wang": "https://www.foreseem.com/img/jun.jpg",
    "richard.wang": "https://www.foreseem.com/img/richard.jpg"
};

const nickname_map = {
    "jesse": "Jesse Xu",
    "kenny": "Kenny Wang",
    "jun.wang": "Jun Wang",
    "richard.wang": "Hao Wang",
};

global.animation = (localStorage.getItem("animation") || "true") === "true";
global.warningTone = (localStorage.getItem("warningTone") || "false") === "true";

global.updateFrequency = +(localStorage.getItem("updateFrequency") || 1000);
global.defaultTab = localStorage.getItem("defaultTab") || "ActSum";
global.pageZoom = +(localStorage.getItem("pageZoom") || 100);
global.chart = localStorage.getItem("chart") || "None";

global.DefaultTabOptions = ["ActSum", "MonitorSummary", "ServerMonitor"];
global.ws = {};

function enableDarkMode () {
    $("#root").css("font-weight", 500);
    enable();
}

function disableDarkMode () {
    $("#root").css("font-weight", 600);
    disable();
}

// function isTouchSafari() {
//     return navigator.userAgent.includes('Safari') && !navigator.userAgent.includes('Chrome') && navigator.maxTouchPoints > 0
// }
//
// function isTouchChrome() {
//     return navigator.userAgent.includes('Chrome') && navigator.maxTouchPoints > 0
// }

function isTouchDevice () {
    return navigator.maxTouchPoints > 0;
}

function isiPhone () {
    return navigator.userAgent.includes("iPhone") && navigator.maxTouchPoints > 0;
}

/**
 * build login page
 */


export default class Home extends React.Component {
    constructor () {
        super();

        this.state = {
            testing: true,
            collapsed: true,
            username: undefined,
            password: undefined,
            menuCurrentKey: "",
            wrongContent: "",
            wrongCount: 0,
            index: "",
            mode: "inline",
            path: "",
            openKeys: [],
            rootSubmenuKeys: [],
            collapsedWidth: 80,
            navHidden: false,
            // siderHidden: false,
            settingVisible: false,
            mouseLeaveSetting: true,

            animation: (localStorage.getItem("animation") || "true") === "true",
            darkMode: (localStorage.getItem("darkMode") || "false") === "true",
            warningTone: (localStorage.getItem("warningTone") || "false") === "true",
            siderHidden: (localStorage.getItem("siderHidden") || "false") === "true",
            chartHidden: (localStorage.getItem("chartHidden") || "true") === "true",
            mobileMode: (localStorage.getItem("mobileMode") || "false") === "true",  //isTouchDevice(),

            updateFrequency: +(localStorage.getItem("updateFrequency") || 1000),
            defaultTab: localStorage.getItem("defaultTab") || "ActSum",
            pageZoom: +(localStorage.getItem("pageZoom") || 100),
            chart: localStorage.getItem("chart") || "Top",

            notification: (localStorage.getItem("notification") || "true") === "true",
            notifyDuration: +(localStorage.getItem("notifyDuration") || 5),
        };
        this.username = localStorage.getItem("username");
        this.role = localStorage.getItem("user");

        this.updateFreqOptions = this.username === "jesse" ? [100, 250, 500, 1000, 3000] : [500, 1000, 3000];
        // this.TabOptions = ['ActSum', 'MonitorSummary', 'ServerMonitor'];
        this.pageZoomOptions = [50, 60, 75, 85, 100, 101, 125, 150];
        this.chartOptions = ["None", "Top",]; // 'Left', ];
        this.notifyDurationOptions = [1, 3, 5, 10, 60, 300, 3600];
        this.zoomWidthMap = {
            50: "305%",
            60: "245%",
            75: "230%",
            85: "215%",
            100: "178%",
            101: "160%",
            125: "160%",
            150: "130%"
        };
        // this.zoomWidthMap = {50: '280%', 60: '245%', 75: '230%', 85: '215%', 100: '250%', 125: '160%', 150: '130%'};
        this.zoomHeightMap = { 50: 2.83, 60: 2.5, 75: 2.3, 85: 2.13, 100: 1.75, 101: 1.6, 125: 1.2, 150: 1.0 };

        // this.safariMode = isTouchSafari();
        // this.chromeMode = isTouchChrome();
        // this.desktopMode = isPC();

        if (isiPhone()) {
            this.zoomWidthMap = {
                50: "450%",
                60: "425%",
                75: "400%",
                85: "375%",
                100: "320%",
                101: "320%",
                125: "200%",
                150: "100%"
            };
            this.zoomHeightMap = { 50: 3.5, 60: 3.2, 75: 3, 85: 2.75, 100: 2.8, 101: 2.8, 125: 2, 150: 2 };
        }

        if (localStorage.getItem("darkMode") === "true") {
            enableDarkMode();
        }

        // window.addEventListener('resize', () => {
        //     this.setState({
        //         testing: !this.state.testing
        //     });
        // });

        // setInterval(() => {
        //     console.log((this.state.mobileMode ? this.zoomHeightMap[100] : 1) * window.innerHeight)
        // }, 5000)
    }

    toggleSider () {
        if (this.state.siderHidden) {
            this.setState({
                siderHidden: false,
                collapsed: true,
                // mode: "vertical"
            });
        }
        else {
            this.setState({
                siderHidden: true,
                collapsed: true,
                // mode: "vertical"
            });
        }
    }

    toggle = () => {
        if (this.state.mobileMode) {
            this.toggleSider();
        }
        else {
            if (this.state.siderHidden) {
                this.setState({
                    siderHidden: false,
                    collapsed: true,
                    // mode: "vertical"
                });
            }
            else {
                this.setState({
                    collapsed: !this.state.collapsed,
                });
            }
        }
    };

    logout () {
        localStorage.setItem("user", "");
        localStorage.setItem("password", "");
        localStorage.setItem("permission", "{}");
        localStorage.setItem("avatar", "");
        localStorage.setItem("nickname", "");

        $.ajax({
            method: "get",
            url: cnf["restUrl"] + "/logout",
            success: () => {
                this.props.history.push("/login");
            },
            error: () => {
            }
        });
    }

    componentWillMount () {
        let that = this;

        // Try session check first (session cookie may still be valid with maxAge)
        $.ajax({
            method: "get",
            url: cnf["restUrl"] + "/permission",
            timeout: 10000,
            success: (data) => {
                // Session is still valid, load dashboard directly
                this.loadDashboard();
                if (data) {
                    localStorage.setItem("permission", JSON.stringify(data));
                }
                let CloseIndex = 0;

                this.timeid = setInterval(() => {
                    if (that.state.index.length === 0) {
                        CloseIndex++;
                        this.loadDashboard();

                        this.state.wrongCount = CloseIndex;
                    }
                    else {
                        this.state.wrongCount = 0;
                        clearInterval(this.timeid);
                    }
                }, 10000);
            },
            error: (error) => {
                // Session expired or invalid, try auto-login with stored credentials
                console.log("Session check failed, attempting auto-login...", error);
                $.ajax({
                    method: "post",
                    url: cnf["restUrl"] + "/login",
                    timeout: 10000,
                    data: {
                        username: localStorage.getItem("username") || "guest",
                        password: localStorage.getItem("password") || "pass"
                    },
                    success: (data) => {
                        localStorage.setItem("user", JSON.parse(data)["user"]);

                        this.loadDashboard();
                        let CloseIndex = 0;

                        this.timeid = setInterval(() => {
                            if (that.state.index.length === 0) {
                                CloseIndex++;
                                this.loadDashboard();

                                this.state.wrongCount = CloseIndex;
                            }
                            else {
                                this.state.wrongCount = 0;
                                clearInterval(this.timeid);
                            }
                        }, 10000);
                    },
                    error: (data) => {
                        console.log("error data: ", data);
                        if (data && data.status === 401) {  // unauthorized
                            this.props.history.push("/login");
                        }
                        else {
                            this.state.wrongCount++;
                            this.props.history.push("/login");
                            this.setState({ wrongContent: `Login failed: ${data.statusText} - ${data.status}, retry [${this.state.wrongCount}] in 10 seconds ...` });
                            setTimeout(() => this.componentWillMount(), 10000);
                        }
                    }
                });
            }
        });
    }

    componentDidMount () {
        this.setState({
            path: this.props.match.path
        });
    }

    loadDashboard () {
        $.ajax({
            method: "get",
            url: cnf["restUrl"] + "/dashboard",
            success: (data) => {
                let menus = Object.keys(data);
                this.setState({
                    index: data, rootSubmenuKeys: menus,
                    // openKeys: menus.length === 0 ? menus : [menus[0]]
                });
                localStorage.setItem("dashboardLinks", JSON.stringify(data));
                this.setState({ wrongContent: "" });
            },
            error: (data) => {
                this.setState({ wrongContent: `Loading dashboard failed: ${data.statusText} - ${data.status}, retry [${this.state.wrongCount}] in 10 seconds ...` });
                console.log("loadDashboard| error data: ", data);
            }
        });
    }

    onOpenChange (openKeys) {
        let that = this;
        const latestOpenKey = openKeys.find(key => that.state.openKeys.indexOf(key) === -1);
        if (that.state.rootSubmenuKeys.indexOf(latestOpenKey) === -1) {
            that.setState({ openKeys: openKeys });
        }
        else {
            that.setState({
                openKeys: latestOpenKey ? [latestOpenKey] : [],
            });
        }
    }

    invertKeyValues = obj =>
        Object.keys(obj).reduce((acc, key) => {
            acc[obj[key]] = key;
            return acc;
        }, {});

    render () {
        // let index = this.state.index;
        const { index, pageZoom, wrongContent, chart } = this.state;
        const hash = document.location.hash;

        const pmcPage = hash.startsWith("#/portfolio_monitor_config");
        const tapeHidden = pmcPage;

        let chartHidden = this.state.chartHidden;
        if (hash.startsWith("#/home") || pmcPage) {
            chartHidden = true;
        }

        if (index === "") {
            return (
                <div style={{ margin: "0 auto", paddingTop: "20%", paddingLeft: "50%", width: "100%" }}><Spin
                    size="large" tip={wrongContent || "Loading ..."}/></div>);
        }
        return (
            <div>
                <Layout hasSider={true} style={{
                    height: "100%",
                    minHeight: window.innerHeight,  // (!isPC() ? 1.5 : 1) * window.innerHeight,  // window.innerHeight,
                    // minHeight: (this.state.mobileMode ? this.zoomWidthMap[pageZoom] : 1) * window.innerHeight,  // (!isPC() ? 1.5 : 1) * window.innerHeight,  // window.innerHeight,
                    width: "100%",
                    // minWidth: window.innerWidth < 1200 ? '150%' : '100%',
                    // {50: '250%', 75: '215%', 85: '200%', 100: '150%', 125: '125%', 150: '100%'};
                    minWidth: this.state.mobileMode ? this.zoomWidthMap[pageZoom] : "100%", //  '135%' : '100%' , //(window.innerWidth / 12 + '%') : '100%',  // 1.5 : 1
                    // minWidth: this.state.mobileMode ? '305%': '100%', //  '135%' : '100%' , //(window.innerWidth / 12 + '%') : '100%',  // 1.5 : 1
                    // minWidth: !this.desktopMode ? this.zoomWidthMap[pageZoom] : (this.state.mobileMode && window.innerWidth < 1800 ? this.zoomWidthMap[pageZoom] : '100%'), //  '135%' : '100%' , //(window.innerWidth / 12 + '%') : '100%',  // 1.5 : 1
                }}>
                    <Sider
                        hidden={this.state.siderHidden}
                        trigger={null}
                        collapsible
                        collapsed={this.state.collapsed}
                        reverseArrow={true}
                        width={"260"}
                        breakpoint="xl"
                        collapsedWidth={this.state.collapsedWidth}
                        onBreakpoint={(broken) => {
                            if (broken) {
                                // console.log('current display as mobile mode.')
                                this.setState({
                                    // collapsedWidth: 0,
                                    // mobileMode: true,
                                    // siderHidden: true,
                                    navHidden: true,
                                });
                            }
                            else {
                                this.setState({
                                    // collapsedWidth: 80,
                                    // mobileMode: false,
                                    // siderHidden: false,
                                    navHidden: false,
                                });
                            }
                        }}
                        style={{
                            overflow: "auto",
                            height: "100%",
                            position: "fixed",
                            left: 0,
                            zIndex: 10
                        }}
                    >

                        <div style={{ padding: "10px", opacity: 0.95 }}>
                            {/*<a href="https://www.foreseem.com" target="_blank">*/}
                            <a onClick={() => window.location.reload()}>
                                {this.state.collapsed ?
                                    <img src={logo_small} style={{ width: "110%", padding: "0%", cursor: "pointer" }}
                                         alt={"logo"}/> :
                                    <img src={logo_large} style={{ width: "100%", padding: "0%", cursor: "pointer" }}
                                         alt={"logo"}/>
                                }
                            </a>
                        </div>

                        <Menu
                            theme="dark"
                            mode={this.state.mode}
                            openKeys={this.state.openKeys}
                            onOpenChange={(e) => this.onOpenChange(e)}
                            selectedKeys={[this.state.menuCurrentKey]}
                            onClick={(e) => this.handleMenuItemClick(e)}
                        >
                            {Object.keys(index).map((item) => {
                                let menuItem = index[item];
                                menuItem = this.invertKeyValues(menuItem);
                                return (
                                    <SubMenu key={item} title={<span>{ico_map[item] ||
                                        <QuestionOutlined/>}<span><strong>{item}</strong></span></span>}>
                                        {Object.keys(menuItem).filter(k => !(k.includes("Monitor Config") && this.role.startsWith("investor"))).map((pageItem) => {
                                            return (
                                                <Menu.Item key={pageItem} onClick={() => {
                                                    this.props.history.push(menuItem[pageItem]);
                                                }}>
                                                    <span>{pageItem}</span>
                                                </Menu.Item>
                                            );
                                        })}
                                    </SubMenu>
                                );
                            })}
                            <Menu.Item key="2" onClick={() => {
                            }}>
                                <UserOutlined/>
                                <span><strong>{" Account"}</strong></span>
                            </Menu.Item>
                            <Menu.Item key="3" onClick={() => {
                                this.logout();
                            }}>
                                <LogoutOutlined/>
                                <span><strong>{" Logout"}</strong></span>
                            </Menu.Item>
                        </Menu>
                    </Sider>
                    <Layout id="home_layout" style={{
                        marginLeft: this.state.siderHidden ? 0 : (this.state.collapsed ? 80 : 260),
                        transition: "margin 0.2s"
                    }}>
                        <Header className="home-header">
                            {React.createElement(this.state.collapsed ? MenuUnfoldOutlined : MenuFoldOutlined, {
                                className: "trigger",
                                onClick: this.toggle,
                                style: { opacity: 0.99, padding: "3px 30px" },

                            })}
                            <div style={{ display: "inline", position: "absolute", padding: "21px 0px" }}>
                                <Breadcrumb separator=">" className="home-breadcrumb">
                                    <Breadcrumb.Item onClick={this.state.mobileMode ? () => {window.location.reload()} : () => this.props.history.push("/home")}>
                                        <strong>FORESEEM</strong></Breadcrumb.Item>
                                    {!this.state.navHidden && this.getCurrentPageHeader().map((item, i) => {
                                        if (i === 1 && item.includes("Monitor")) {
                                            const new_href = "/" + (pmcPage ? hash.replace("monitor_config", "monitor") : hash.replace("monitor", "monitor_config"));
                                            const title = pmcPage ? "Switch to Monitor" : "Switch to Config";
                                            return (<Breadcrumb.Item title={title} href={new_href}
                                                                     key={item}><strong>{item}</strong></Breadcrumb.Item>);
                                        }
                                        else {
                                            return (<Breadcrumb.Item key={item}>{item}</Breadcrumb.Item>);
                                        }
                                    })}
                                </Breadcrumb>
                            </div>
                            <div style={{
                                display: "inline",
                                position: "fixed",
                                right: "-0.5%",
                                cursor: "pointer",
                                margin: "0px 24px",
                                height: "inherit",
                                whiteSpace: "nowrap",
                                transition: "left 0.2s"
                            }}
                                 onBlur={() => {
                                     setTimeout(() => {
                                         if (this.state.settingVisible && this.state.mouseLeaveSetting) {
                                             this.setState({ settingVisible: false });
                                         }
                                     }, 100);
                                 }}
                            >
                                <Avatar
                                    src={localStorage.getItem("avatar") || avatar_map[this.username] || default_avatar}
                                    size={"normal"} style={{ margin: "0 15px" }}/>
                                <strong>{localStorage.getItem("nickname") || nickname_map[this.username] || this.username}</strong>
                                {React.createElement(SettingOutlined, {
                                    className: "trigger",
                                    style: { opacity: 0.99, padding: "0 35px" },
                                    onClick: () => {
                                        if (this.state.settingVisible) {
                                            this.setState({ settingVisible: false });
                                        }
                                        else {
                                            this.setState({ settingVisible: true });
                                        }
                                    }
                                })}
                                <Menu
                                    className="setting-menu"
                                    hidden={!this.state.settingVisible}
                                    // bordered={true}
                                    style={{ onHover: { background: "rgba(0, 0, 0, 0.025)" } }}
                                    onMouseEnter={() => {
                                        this.setState({ mouseLeaveSetting: false });
                                    }}
                                    onMouseLeave={() => {
                                        this.setState({ mouseLeaveSetting: true });
                                    }}
                                >
                                    <Menu.Item key="Notification">
                                        <b style={{ paddingLeft: "0px" }}>Notification</b>
                                        <Switch
                                            style={{ position: "absolute", right: "12px", margin: "9px" }}
                                            // size={"small"}
                                            defaultChecked={!!global.notification}
                                            checked={!!global.notification}
                                            checkedChildren={<NotificationFilled
                                                style={{ fontSize: "13px", margin: "4.5px 0" }}/>}
                                            unCheckedChildren={<NotificationOutlined
                                                style={{ fontSize: "13px", margin: "4.5px 0" }}/>}
                                            onChange={(e) => {
                                                // const checked = e.target.checked;
                                                global.notification = e;
                                                this.setState({ notification: e });
                                                localStorage.setItem("notification", String(e));
                                            }}
                                        />
                                    </Menu.Item>
                                    <Menu.Item key="Sound">
                                        <b style={{ marginLeft: "0px" }}>Sound</b>
                                        <Switch
                                            style={{ position: "absolute", right: "12px", margin: "9px" }}
                                            // size={"small"}
                                            defaultChecked={!!global.warningTone}
                                            checked={!!global.warningTone}
                                            checkedChildren={<BellFilled
                                                style={{ fontSize: "13px", margin: "4.5px 0" }}/>}
                                            unCheckedChildren={<BellOutlined
                                                style={{ fontSize: "13px", margin: "4.5px 0" }}/>}
                                            onChange={(e) => {
                                                // const checked = e.target.checked;
                                                global.warningTone = e;
                                                this.setState({ warningTone: e });
                                                localStorage.setItem("warningTone", String(e));

                                                if (e) {
                                                    new Audio("https://www.foreseem.com/audio/catoo.mp3").play()
                                                        .then(() => {
                                                            if (global.notification) {
                                                                openNotificationWithIcon("warning", `Sound Alert: Turn on Audio`);
                                                            }
                                                        });
                                                }
                                            }}
                                        />
                                    </Menu.Item>
                                    <Menu.Item key="Animation">
                                        <b style={{ marginLeft: "0px" }}>Animation</b>
                                        <Switch
                                            style={{ position: "absolute", right: "12px", margin: "9px" }}
                                            // size={"small"}
                                            defaultChecked={this.state.animation}
                                            checked={this.state.animation}
                                            checkedChildren={<ThunderboltFilled
                                                style={{ fontSize: "13px", margin: "4.5px 0" }}/>}
                                            unCheckedChildren={<ThunderboltOutlined
                                                style={{ fontSize: "13px", margin: "4.5px 0" }}/>}
                                            onChange={(e) => {
                                                // const checked = e.target.checked;
                                                global.animation = e;
                                                this.setState({ animation: e });
                                                localStorage.setItem("animation", String(e));
                                            }}
                                        />
                                    </Menu.Item>
                                    <Menu.Item key="DarkMode">
                                        <b style={{ marginLeft: "0px" }}>Night Mode</b>
                                        <Switch
                                            style={{ position: "absolute", right: "12px", margin: "9px" }}
                                            // size={"small"}
                                            defaultChecked={this.state.darkMode}
                                            checked={this.state.darkMode}
                                            checkedChildren={<BulbFilled
                                                style={{ fontSize: "13px", margin: "4.5px 0" }}/>}
                                            unCheckedChildren={<BulbOutlined
                                                style={{ fontSize: "13px", margin: "4.5px 0" }}/>}
                                            onChange={(e) => {
                                                if (e) {
                                                    enableDarkMode();
                                                }
                                                else {
                                                    disableDarkMode();
                                                }
                                                this.setState({ darkMode: e });
                                                localStorage.setItem("darkMode", String(e));
                                            }}
                                        />
                                    </Menu.Item>
                                    <Menu.Item key="MobileMode">
                                        <b style={{ marginLeft: "0px" }}>Mobile Mode</b>
                                        <Switch
                                            style={{ position: "absolute", right: "12px", margin: "9px" }}
                                            // size={"small"}
                                            defaultChecked={this.state.mobileMode}
                                            checked={this.state.mobileMode}
                                            checkedChildren={<MobileFilled
                                                style={{ fontSize: "13px", margin: "4.5px 0" }}/>}
                                            unCheckedChildren={<MobileOutlined
                                                style={{ fontSize: "13px", margin: "4.5px 0" }}/>}
                                            onChange={(e) => {
                                                this.setState({ mobileMode: e });
                                                localStorage.setItem("mobileMode", String(e));
                                            }}
                                        />
                                    </Menu.Item>
                                    <Menu.Item key="HideChart">
                                        <b style={{ marginLeft: "0px" }}>Hide Chart</b>
                                        <Switch
                                            style={{ position: "absolute", right: "12px", margin: "9px" }}
                                            // size={"small"}
                                            defaultChecked={this.state.chartHidden}
                                            checked={this.state.chartHidden}
                                            checkedChildren={<LineChartOutlined
                                                style={{ fontSize: "13px", margin: "4.5px 0" }}/>}
                                            unCheckedChildren={<LineChartOutlined
                                                style={{ fontSize: "13px", margin: "4.5px 0" }}/>}
                                            onChange={(e) => {
                                                this.setState({ chartHidden: e });
                                                localStorage.setItem("chartHidden", String(e));
                                            }}
                                        />
                                    </Menu.Item>
                                    <Menu.Item key="HideSider">
                                        <b style={{ marginLeft: "0px" }}>Hide Sider</b>
                                        <Switch
                                            style={{ position: "absolute", right: "12px", margin: "9px" }}
                                            // size={"small"}
                                            defaultChecked={this.state.siderHidden}
                                            checked={this.state.siderHidden}
                                            checkedChildren={<CaretLeftOutlined
                                                style={{ fontSize: "13px", margin: "4.5px 0" }}/>}
                                            unCheckedChildren={<CaretRightOutlined
                                                style={{ fontSize: "13px", margin: "4.5px 0" }}/>}
                                            onChange={(e) => {
                                                this.setState({ siderHidden: e });
                                                localStorage.setItem("siderHidden", String(e));
                                            }}
                                        />
                                    </Menu.Item>
                                    <Menu.Item key="UpdateFreq" style={{ borderColor: "#727880" }}>
                                        <b style={{ marginLeft: "0px", fontSize: "12px" }}>UpdateFreq</b>
                                        <Select
                                            defaultValue={this.state.updateFrequency + "ms"}
                                            placeholder={this.state.updateFrequency + "ms"}
                                            size={"small"}
                                            bordered={true}
                                            defaultActiveFirstOption={false}
                                            style={{
                                                width: "50%",
                                                border: "1px solid #40a9ff",
                                                fontSize: "11px",
                                                position: "absolute", right: "12px", margin: "8px"
                                            }}
                                            onSelect={(value) => {
                                                value = +value.replace("ms", "");
                                                global.updateFrequency = value;
                                                this.setState({ updateFrequency: value });
                                                localStorage.setItem("updateFrequency", String(value));
                                            }}
                                        >
                                            {this.updateFreqOptions.map((option, index) => {
                                                return (<Select.Option value={option + "ms"}
                                                                       key={index}>{option}ms</Select.Option>);
                                            })}
                                        </Select>
                                    </Menu.Item>
                                    <Menu.Item key="DefaultTab" hidden={this.username !== "jesse"}
                                               style={{ borderColor: "#727880" }}>
                                        <b style={{ marginLeft: "0px", fontSize: "12px" }}>DefaultTab</b>
                                        <Select
                                            defaultValue={this.state.defaultTab}
                                            placeholder={this.state.defaultTab}
                                            size={"small"}
                                            bordered={true}
                                            defaultActiveFirstOption={false}
                                            style={{
                                                width: "50%",
                                                border: "1px solid #40a9ff",
                                                fontSize: "11px",
                                                position: "absolute", right: "12px", margin: "8px"
                                            }}
                                            onSelect={(value) => {
                                                global.defaultTab = value;
                                                this.setState({ defaultTab: value });
                                                localStorage.setItem("defaultTab", value);
                                            }}
                                        >
                                            {global.DefaultTabOptions.map((option, index) => {
                                                return (
                                                    <Select.Option value={option} key={index}>{option}</Select.Option>);
                                            })}
                                        </Select>
                                    </Menu.Item>
                                    <Menu.Item key="NotifyDuration" hidden={this.username !== "jesse"}
                                               style={{ borderColor: "#727880" }}>
                                        <b style={{ marginLeft: "0px", fontSize: "12px" }}>NotifyDuration</b>
                                        <Select
                                            defaultValue={this.state.notifyDuration + "s"}
                                            placeholder={this.state.notifyDuration + "s"}
                                            size={"small"}
                                            bordered={true}
                                            defaultActiveFirstOption={false}
                                            style={{
                                                width: "50%",
                                                border: "1px solid #40a9ff",
                                                fontSize: "11px",
                                                position: "absolute", right: "12px", margin: "8px"
                                            }}
                                            onSelect={(value) => {
                                                value = +value.replace("s", "");
                                                global.notifyDuration = value;
                                                this.setState({ notifyDuration: value });
                                                localStorage.setItem("notifyDuration", String(value));
                                            }}
                                        >
                                            {this.notifyDurationOptions.map((option, index) => {
                                                return (<Select.Option value={option + "s"}
                                                                       key={index}>{option}s</Select.Option>);
                                            })}
                                        </Select>
                                    </Menu.Item>
                                    <Menu.Item key="PageZoom" hidden={!this.state.mobileMode}
                                               style={{ borderColor: "#727880" }}>
                                        <b style={{ marginLeft: "0px", fontSize: "12px" }}>PageZoom</b>
                                        <Select
                                            defaultValue={this.state.pageZoom + "%"}
                                            placeholder={this.state.pageZoom + "%"}
                                            size={"small"}
                                            bordered={true}
                                            defaultActiveFirstOption={false}
                                            style={{
                                                width: "50%",
                                                border: "1px solid #40a9ff",
                                                fontSize: "11px",
                                                position: "absolute", right: "12px", margin: "8px"
                                            }}
                                            onSelect={(value) => {
                                                value = +value.replace("%", "");
                                                this.setState({ pageZoom: value });
                                                localStorage.setItem("pageZoom", String(value));

                                                // document.body.style.zoom = `${value}%`;

                                                // let scale = value / 100;
                                                // let content = `width=device-width, initial-scale=${scale}, maximum-scale=${scale}, minimum-scale=${scale}`;
                                                // let meta = document.querySelector('meta[name=viewport]')
                                                // if(!meta) {
                                                //     meta = document.createElement('meta')
                                                //     meta.setAttribute('name', 'viewport')
                                                //     document.head.appendChild(meta)
                                                // }
                                                // meta.setAttribute('content', content)

                                                // transform: scale(0.9);
                                                // document.body.style.transform=`scale(${value/100})`;
                                                // document.body.style.transformOrigin=`0 0`;
                                            }}
                                        >
                                            {this.pageZoomOptions.map((o, index) => {
                                                return (
                                                    <Select.Option value={o + "%"} key={index}>{o}%</Select.Option>);
                                            })}
                                        </Select>
                                    </Menu.Item>
                                    <Menu.Item key="chart" style={{ borderColor: "#727880" }}>
                                        <b style={{
                                            marginLeft: "0px",
                                            fontSize: "12px"
                                        }}>{chartHidden ? "TickerTape" : "KlineChart"}</b>
                                        <Select
                                            defaultValue={this.state.chart}
                                            placeholder={this.state.chart}
                                            size={"small"}
                                            bordered={true}
                                            defaultActiveFirstOption={false}
                                            style={{
                                                width: "50%",
                                                border: "1px solid #40a9ff",
                                                fontSize: "11px",
                                                position: "absolute", right: "12px", margin: "8px"
                                            }}
                                            onSelect={(value) => {
                                                this.setState({ chart: value });
                                                localStorage.setItem("chart", value);
                                            }}
                                        >
                                            {this.chartOptions.map((o, index) => {
                                                return (<Select.Option value={o} key={index}>{o}</Select.Option>);
                                            })}
                                        </Select>
                                    </Menu.Item>
                                </Menu>
                            </div>
                        </Header>
                        <Content className="home-content"
                                 style={{ "minHeight": (this.state.mobileMode ? this.zoomHeightMap[pageZoom] : 1) * window.outerHeight }}>
                            {/*<Content className="home-content">*/}
                            {!tapeHidden && chart === "Top" && (
                                <div className="home-tradingview-tickers-top"><TradingViewTickers/></div>)}
                            {!chartHidden && chart === "Top" && (
                                <div className="home-tradingview-chart-top"><TradingViewChart/></div>)}

                            {/*{!chartHidden && chart === 'Left' && (<div className="home-tradingview-container-left"><TradingViewChart/></div>)}*/}
                            <Router>
                                <RouteSwitch>
                                    <Route exact path="/home" component={DashBoard}/>
                                    <Route exact path="/dashboard" component={DashBoard}/>
                                    <Route exact path="/portfolio_monitor" component={PortfolioMonitor}/>
                                    <Route exact path="/portfolio_monitor_config" component={PortfolioMonitorConfig}/>
                                </RouteSwitch>
                            </Router>
                        </Content>
                        {/*<Footer style={{textAlign: 'center'}} >FORESEEM © {new Date().getFullYear()}</Footer>*/}
                    </Layout>
                </Layout>
            </div>
        );
    }

    changeMode () {
        let mode = this.state.mode;
        if (mode === "inline") {
            mode = "vertical";
        }
        else if (mode === "vertical") {
            mode = "inline";
        }
        this.setState({
            mode: mode
        });
    }

    getCurrentPageHeader () {
        let index = this.state.index;
        if (index === "") {
            return [];
        }
        else {
            for (let item of Object.keys(index)) {
                for (let name of Object.keys(index[item])) {
                    if (name === this.props.history.location.pathname + this.props.history.location.search) {
                        return ([item, index[item][name]]);
                    }
                }
            }
            return [];
        }
    }

    handleMenuItemClick (e) {
        this.setState({
            menuCurrentKey: e.key,
        });
    }
}



// WEBPACK FOOTER //
// ./src/view/Home.js